import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { parseUnknownToString } from "@tsp-core/utils/string";

import { SoulEntityContentType } from "../enums";
import { SoulEntityContentUuid, SoulEntityOrderUuid } from "../types";

export function parseSoulEntityContentUuid<Input>(
  input: Input,
): Input extends SoulEntityContentUuid ? SoulEntityContentUuid : SoulEntityContentUuid | null {
  const uuid = parseUnknownToString(input);
  if (checkIsNotNullish(uuid)) {
    return uuid as SoulEntityContentUuid;
  }

  return null;
}

export function parseSoulEntityContentType<Input>(
  input: Input,
): Input extends SoulEntityContentType ? SoulEntityContentType : SoulEntityContentType | null {
  const type = parseUnknownToString(input);
  if (checkIsNotNullish(type)) {
    return type as SoulEntityContentType;
  }

  return null;
}

export function parseSoulEntityOrderUuid<Input>(
  input: Input,
): Input extends SoulEntityOrderUuid ? SoulEntityOrderUuid : SoulEntityOrderUuid | null {
  const uuid = parseUnknownToString(input);
  if (checkIsNotNullish(uuid)) {
    return uuid as SoulEntityOrderUuid;
  }

  return null;
}
